const taskTemplates = require('../../task-templates');

const tasksData = [
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 1,
		taskId: 'teaching-order-typical-day',
		title: 'Opgave 1',
		text: `Hvordan tror I, en typisk dag på HF ser ud? Sæt i den rækkefølge, I mener, den foregår.`,
		hintText: `Den kan være på mange måder, så den rigtige læsning er blot en af mange muligheder - så et par af dem bliver I nødt til at gætte jer til.`,
		popupText: `En skoledag på HF består af mange forskellige aktiviteter – fra klasseundervisning til gruppearbejde og pauser.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Møde i klassen`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Faglig undervisning`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Gruppearbejde/projekt`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Pause`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Mundtlig fremlæggelse`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Tid til at gå hjem`, correctOrderNumbers: [6]
			})
		]
	}),
	Object.assign({}, taskTemplates.paperDollTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'teaching-paper-doll-teaching-items',
		avatarId: 'avatar-4',
		text: `Gør eleven klar til en dag i gymnasiet, hvad tror I hun har brug for? Vælg de rigtige ting, og klik OK, når I har valgt de vigtige ting.`,
		hintText: `Nogle af tingene giver vist ikke mening.`,
		popupText: `Kamera, høje hæle og arbejdstøj er vist ikke nødvendigt for gymnasiet. Men heller ikke forbudt.`,
		items: [
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'work-coat', title: 'Arbejdstøj'
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'backpack', title: 'Rygsæk med bøger og notesbog', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'computer-b', title: 'Laptop eller tablet til undervisningen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'pencil-case', title: 'Penalhus med blyanter, kuglepen og lommeregner', isCorrect: true
			}),
			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'high-heels', title: 'Høje hæle'
			}),

			Object.assign({}, taskTemplates.paperDollTemplate.itemTemplate, {
				id: 'camera-b', title: 'Kamera'
			})
		]
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 1,
		taskNumber: 3,
		title: 'Opgave 3',
		taskId: 'teacher-mc-teaching-truths',
		text: `Hvad tror I er sandt om undervisningen på HF?`,
		hintText: `I kan nemt finde svaret her: 
			<br /><br />https://www.ug.dk/uddannelser-til-unge/gymnasiale-uddannelser/hf-eksamen-hf`,
		popupText: `På HF veksler undervisningen mellem klasseundervisning, gruppearbejde og lektier, så der er variation i hverdagen.`,
		image: 'stx-group-work',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Du får både klasseundervisning, gruppearbejde og projektarbejde', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Forberedelse og lektier fylder en del af hverdagen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Man afleverer kun én skriftlig opgave pr. år'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Alle eksamener ligger kun i 2.g'
			})
		],
	}),
	/* Case 2 */
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 1,
		taskId: 'teaching-sort-subjects-1',
		title: 'Opgave 1A',
		text: `På gymnasiet får du mange nye fag – og de kræver forskelligt udstyr. Hvilket hører til hvilke fag, tror I? Træk tingene til den rigtige kategori.`,
		hintText: `Tal sammen om hvilket fag, tingene typisk bruges i.`,
		popupText: `Hvert fag i gymnasiet har sit eget typiske udstyr, som man bruger til undervisningen.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'biology', title: `Biologi`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'physics', title: `Fysik`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'chem', title: `Kemi`}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Mikroskop`, categoryIds: ['biology']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Petriskåle`, categoryIds: ['biology']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Magnet`, categoryIds: ['physics']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Geigertæller`, categoryIds: ['physics']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Reagensglas`, categoryIds: ['chem']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Pipette`, categoryIds: ['chem']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Kittel`, categoryIds: ['chem']})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 2,
		taskId: 'teaching-sort-subjects-2',
		lockedById: 'teaching-sort-subjects-1',
		title: 'Opgave 1B',
		text: `I har allerede sorteret udstyr til fysik, kemi og biologi – men hvad med andre fag på gymnasiet? Hvilket hører til hvilke fag, tror I? Træk tingene til den rigtige kategori.`,
		hintText: `Tal sammen om hvilket fag, tingene typisk bruges i.`,
		popupText: `Hvert fag i gymnasiet har sit eget typiske udstyr, som man bruger til undervisningen.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'math', title: `Matematik`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'pe', title: `Idræt`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'music', title: `Musik`}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Lommeregner`, categoryIds: ['math']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Geometrisæt`, categoryIds: ['math']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Grafer og diagrammer`, categoryIds: ['math']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Indendørssko`, categoryIds: ['pe']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Stopur`, categoryIds: ['pe']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Træningstrøje`, categoryIds: ['pe']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Noder`, categoryIds: ['music']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 8, text: `Guitar`, categoryIds: ['music']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 9, text: `Trommestikker`, categoryIds: ['music']})
		]
	}),
	Object.assign({}, taskTemplates.sortTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 3,
		taskId: 'teaching-sort-subjects-3',
		lockedById: 'teaching-sort-subjects-2',
		title: 'Opgave 1C',
		text: `Nu tager vi fat på nogle af de mere kreative og praktiske fag på gymnasiet. Hvilket udstyr hører til hvilke fag, tror I? Træk tingene til den rigtige kategori.`,
		hintText: `Tal sammen om hvilket fag, tingene typisk bruges i.`,
		popupText: `Hvert fag i gymnasiet har sit eget typiske udstyr, som man bruger til undervisningen.`,
		categories: [
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'art', title: `Billedkunst`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'social', title: `Samfundsfag`}),
			Object.assign({}, taskTemplates.sortTemplate.categoryTemplate, {id: 'drama', title: `Drama`}),
		],
		items: [
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 1, text: `Staffeli`, categoryIds: ['art']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 2, text: `Akrylmaling`, categoryIds: ['art']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 3, text: `Politiske debatoplæg`, categoryIds: ['social']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 4, text: `Statistik over befolkningstal`, categoryIds: ['social']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 5, text: `Kostumer`, categoryIds: ['drama']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 6, text: `Manuskript`, categoryIds: ['drama']}),
			Object.assign({}, taskTemplates.sortTemplate.itemTemplate, {id: 7, text: `Rekvisitter`, categoryIds: ['drama']})
		]
	}),
Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 4,
		subtype: 'images',
		title: 'Opgave 2',
		taskId: 'teaching-mc-classroom-hours',
		text: `På HF tilbringer man ret mange timer i klasselokalet – men hvor mange tror I, det egentlig er om ugen?`,
		hintText: `Det handler om et realistisk ugentligt timetal som ChatGPT helt sikkert vil kunne vejlede jer i.`,
		// popupText: `Det er det officielle timetal man typisk bruger. Dog kan forskellige personer have forskellige opfattelser.`,
		layout: 'hf-classroom-hours',
		shuffleOptions: false,
		image: 'stx-classroom-science',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4
			})
		],
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 5,
		title: 'Opgave 3',
		taskId: 'teaching-input-responsibility',
		text: `På universitetet er der ingen, der tjekker, om du følger med, det er dit eget ansvar – men hvad med gymnasiet? Tror I, lærerne sikrer at eleverne følger med her?`,
		hintText: `Det er et simplelt ja eller nej vi leder efter.`,
		popupText: `På gymnasiet har lærere stadig et stort ansvar for, at eleverne deltager i timerne.`,
		answer: 'Ja',
		subtype: 'string',
		unit: null,
		image: 'stx-classroom-teaching'
	}),
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 2,
		taskNumber: 6,
		title: 'Opgave 4',
		taskId: 'teacher-mc-wellbeing',
		text: `Trivsel er noget, gymnasierne tager alvorligt – men hvad tror I, de typisk gør for at hjælpe eleverne til at have det godt?`,
		hintText: `Tænk på, hvordan skolen kan hjælpe med at gøre jer gladere på en realistisk måde.`,
		popupText: `På HF arbejder lærere og skolen for, at eleverne trives og får støtte, så hverdagen hænger godt sammen.`,
		image: 'stx-teaching-comfy',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'Tilbyder studievejledning og samtaler med elever', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Arrangerer sociale aktiviteter og introforløb', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'Giver mulighed for at vælge kortere skoledage til dem, der ønsker det'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'Tilbyder lektiecaféer og faglig støtte', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'Indfører fridage hver måned for at mindske stress'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'Har faste regler for, hvor mange afleveringer der må ligge samme uge'
			})
		],
	}),

	/* Case 3 */
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 1,
		title: 'Opgave 1',
		taskId: 'teaching-input-most-important',
		text: `På gymnasiet lærer man på forskellige måder – men hvad tror I fylder mest på HF? Skriv den af disse muligheder I tror passer: Teori, Praksis eller En blanding.`,
		hintText: `Overvej, hvad gymnasiet mest er kendt for – og hvordan timerne oftest foregår.`,
		popupText: `HF handler om både teori og praksis.`,
		answer: 'En blanding',
		subtype: 'string',
		unit: null
	}),	
	Object.assign({}, taskTemplates.multipleChoiceTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 2,
		title: 'Opgave 2',
		taskId: 'teacher-mc-new-things',
		text: `Når man starter i gymnasiet, er der mange nye ting at vænne sig til. Hvad tror I, eleverne bl.a. synes er spændende i starten?`,
		hintText: `Tænk på, hvad der typisk føles mest nyt og spændende, når man starter et nyt sted med mange nye mennesker.`,
		// popupText: `For de fleste handler det om afleveringer, tempoet og det at stå foran klassen – det er dér, overgangen fra grundskolen virkelig kan mærkes.`,
		// image: 'stx-teaching-classroom',
		options: [
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 1, text: 'At lære hinanden at kende', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 2, text: 'Det højere tempo i undervisningen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 3, text: 'At tale foran hele klassen', isCorrect: true
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 4, text: 'At finde vej til klasselokalerne'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 5, text: 'At vænne sig til kantinemaden'
			}),
			Object.assign({}, taskTemplates.multipleChoiceTemplate.optionTemplate, {
				id: 6, text: 'At bruge nye digitale platforme', isCorrect: true
			})
		],
	}),
	Object.assign({}, taskTemplates.orderTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 3,
		taskId: 'teaching-order-project',
		title: 'Opgave 3',
		text: `Et projektforløb på gymnasiet går igennem flere trin. Hvordan tror I, rækkefølgen ser ud – fra start til slut?`,
		hintText: `Prøv at tænke på, hvad man laver først, midtvejs og til sidst, når man arbejder med et projekt.`,
		popupText: `Et projektforløb på gymnasiet minder meget om det, I kender fra folkeskolen – men går ofte mere i dybden og stiller større krav til samarbejde og selvstændighed.`,
		items: [
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 1, text: `Vælge emne`, correctOrderNumbers: [1]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 2, text: `Lægge en plan for arbejdet`, correctOrderNumbers: [2]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 3, text: `Undersøge materiale og kilder`, correctOrderNumbers: [3]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 4, text: `Skrive rapport`, correctOrderNumbers: [4]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 5, text: `Aflevere rapporten`, correctOrderNumbers: [5]
			}),
			Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 6, text: `Forberede fremlæggelse`, correctOrderNumbers: [6]
			}),
				Object.assign({}, taskTemplates.orderTemplate.itemTemplate, {
				id: 7, text: `Præsentere for klassen`, correctOrderNumbers: [7]
			})
		]
	}),
	Object.assign({}, taskTemplates.inputAnswerTemplate.mainTemplate, {
		caseId: 3,
		taskNumber: 4,
		title: 'Opgave 4',
		taskId: 'teaching-input-test-types',
		text: `På HF slutter året altid med prøver – men hvor mange eksamensformer findes der egentlig? Skriv svaret i tal.`,
		hintText: `Tænk over, hvordan man kan blive testet – det er ikke kun med papir og blyant.`,
		popupText: `På HF er der to typer eksamener – mundtlige og skriftlige.`,
		answer: '2',
		subtype: 'string',
		altAnswers: ['to', '2'],
		unit: null
	}),	
];

let taskIdsArr = [];
tasksData.forEach((task, index) => {
	/* Assign unique id used for navigation */
	task.id = 'stxhf-teaching-' + (index + 1 < 10 ? '0' : '') + (index + 1);

	/* Check taskId is set when required and unique */
	if (task.taskId) {
		if (taskIdsArr.indexOf(task.taskId) >= 0) {
			console.error('Task id not unique: ', task.taskId);
		} else {
			taskIdsArr.push(task.taskId);
		}
	} else {
		console.error('Missing task id for task: ', task);
	}
});

export {
	tasksData
};